module.exports = __webpack_public_path__ + "img/rohit_bh.04ad6cac.png";